// Per-route head tag updater. Called by main.ts on every route change
// (synchronously with placeholder copy) and again when route-specific
// data resolves (river name, blog entry frontmatter).

export type RouteMeta = {
  title: string;
  description: string;
  /** Absolute or root-relative image URL. Optional — falls back to badge. */
  image?: string;
  /** Optional absolute URL override. Default: location.origin + pathname + hash. */
  url?: string;
};

const DEFAULT_IMAGE = '/frozen-fly-badge.png';

export function setRouteMeta(m: RouteMeta): void {
  const url = m.url ?? location.origin + location.pathname + location.hash;
  const image = absolutize(m.image ?? DEFAULT_IMAGE);

  document.title = m.title;
  setMeta('name', 'description', m.description);
  setMeta('property', 'og:title', m.title);
  setMeta('property', 'og:description', m.description);
  setMeta('property', 'og:image', image);
  setMeta('property', 'og:url', url);
  setMeta('name', 'twitter:title', m.title);
  setMeta('name', 'twitter:description', m.description);
  setCanonical(url);
}

function setMeta(attr: 'name' | 'property', key: string, value: string): void {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(url: string): void {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

function absolutize(url: string): string {
  if (/^https?:\/\//.test(url)) return url;
  if (url.startsWith('/')) return location.origin + url;
  return location.origin + '/' + url;
}
